/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OwnerTypeWithRelations } from '../../models/owner-type-with-relations';

export interface GetOwnerTypesList$Params {
}

export function getOwnerTypesList(http: HttpClient, rootUrl: string, params?: GetOwnerTypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OwnerTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getOwnerTypesList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OwnerTypeWithRelations>>;
    })
  );
}

getOwnerTypesList.PATH = '/owner-types';
